export default (store) => ({
  path : 'dashboard',
    /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
        /*  Webpack - use 'require.ensure' to create a split point
         and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      const Dashboard = require('./container').default
      cb(null, Dashboard)
    }, 'dashboard')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Dashboard/index.js